import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  validateReportCriteria,
  insertTitle,
  insertSubTile,
  chooseDownloadableBtn,
  checkDefaultTab
} from '../utilities/report-helpers';

import {
  setInsightsCriteriaType,
  clearInsightsCriteriaBoundaries,
  setInsightsCriteriaBoundaries
} from '../store/actions/criteria-actions';

import {
  fetchMobileDevicesApplicationReport,
  downloadMobileDevices,
  fetchMobileDevicesSummaryCard,
  fetchMobileDevicesReport,
  fetchMobileDevicesNetwork
} from '../store/actions/mobileDevices-actions';

import { setLastInsightPage } from '../store/actions/route-actions';

import {
  formatNumber,
  isEmptyObject,
  isDataAvailable,
  searchStringInObjectArray
} from '../utilities/helpers';

import Header from './Header';
import SVGIcon from '../components/SVGIcon';
import HomeInsightSidebar from './HomeInsightSidebar';
import InsightsNavBar from './InsightsNavBar';
import MobileTableGraph from '../components/MobileTableGraph'
import SelectionNotAvailable from '../components/SelectionNotAvailable';
import CopyrightAndVersion from '../components/CopyrightAndVersion';
import LoadingContainer from '../components/LoadingContainer';
import DownloadPdf from '../components/DownloadPdf';
import DownloadCSVButton from '../components/DownloadCSVButton';

const mapStateToProps = (
  { home, client, reports, insightsCriteria, locations, auth, mobileDevices },
  ownProps
) => ({
  ...home,
  client,
  ...insightsCriteria,
  ...mobileDevices,
  showDownloadButton: client.showHomePage,
  organisationsAvailable: false,
  geographyAvailable: true,
  report: reports.reportDictionary[ownProps.reportId],
  insightType: insightsCriteria.insightType,
  organisation: insightsCriteria.organisation,
  ...locations,
  ableToDownloadCSV: chooseDownloadableBtn('mobileDevices', auth.tokenPayload.scopes, insightsCriteria.insightType)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearInsightsCriteriaBoundaries,
      setInsightsCriteriaBoundaries,
      setInsightsCriteriaType,
      fetchMobileDevicesApplicationReport,
      fetchMobileDevicesReport,
      downloadMobileDevices,
      fetchMobileDevicesSummaryCard,
      fetchMobileDevicesNetwork,
      setLastInsightPage
    },
    dispatch
  );

class MobileDevicesInsights extends React.Component {
  state = {
    sideBarOpen: true,
    currentTimePeriod:
    {
      label: 'Last 90 days',
      value: 90
    },
    currentBrandSelection: null,
    currentCategorySelection: null,
    isLoadTopPoisReport: false,
    showCriteriaModal: false,
    showSelectionWarning: false,
    selectionWarningText: '',
  };

  componentDidMount() {
    this.props.setLastInsightPage('/mobile-device-insights')

    let selectedTab = checkDefaultTab(this.props.reportsType, this.props.insightType, this.props.geographyAvailable, this.props.organisationsAvailable)
    this.props.setInsightsCriteriaType(selectedTab);
    // validate before getdata
    const validateResult = this.handelValidateReportCriteria(selectedTab);
    if( validateResult.showSelectionWarning === false){
      this.loadData('');
    }
  }

  componentDidUpdate = prevProps => {
    if (prevProps.criteriaId !== this.props.criteriaId) {
      // validate before getdata
      let selectedTab = checkDefaultTab(this.props.reportsType, this.props.insightType, this.props.geographyAvailable, this.props.organisationsAvailable)
      this.handelValidateReportCriteria(selectedTab);

    }
  };


  loadData = selectTab => {
    this.props.fetchMobileDevicesApplicationReport();
    this.props.fetchMobileDevicesSummaryCard();
    this.props.fetchMobileDevicesReport();
    this.props.fetchMobileDevicesNetwork();
  };

  handelValidateReportCriteria = (selectedTab) => {

    const reportCriteriaValid = validateReportCriteria({
      insightType: selectedTab,
      report: this.props.report,
      subcategory: null,
      organisation: this.props.organisation,
    });

    this.setState(() => ({
      ...reportCriteriaValid,
    }));
    return reportCriteriaValid;
  };

  toggleSideBar = () =>
    this.setState(prevState => ({ sideBarOpen: !prevState.sideBarOpen }));

  render() {

    const { insightType, downloadingCSV, downloadMobileDevices, reportId, mobileDevicesApplicationDataLoaded, mobileDevicesApplicationData,
      mobileDevicesSummaryDataLoaded, mobileDevicesSummaryData, mobileDevicesReportData, mobileDevicesReportDataLoaded, mobileDevicesNetworkData,
      mobileDevicesNetworkDataLoaded } = this.props

    const headCellsApp = [
      { id: 'name', label: 'Application name' },
      { id: 'percentage', label: 'Customer percentage' },
      { id: 'count', label: 'Customer count' },
      { id: 'devices', label: 'Devices analysed' },
    ];

    const headCellsBrand = [
      { id: 'name', label: 'Device brand name' },
      { id: 'percentage', label: 'Customer percentage' },
      { id: 'count', label: 'Customer count' },
    ];

    const headCellsNetwork = [
      { id: 'name', label: 'Mobile network name' },
      { id: 'percentage', label: 'Customer percentage' },
      { id: 'count', label: 'Customer count' },
    ];


    return (
      <div className="FootfallInsights" data-html2canvas-ignore="true">
        <Header />
        {this.state.sideBarOpen && (
          <HomeInsightSidebar
            loadData={this.loadData}
            toggleSideBar={this.toggleSideBar}
            reportId={this.props.reportId}
            reportsType="mobileDevices"
          />
        )}
        <main
          className={`FootfallInsights_main${
            this.state.sideBarOpen ? '' : ' FootfallInsights_main_full-width'
            }`}
        >
          {!this.state.sideBarOpen && (
            <button
              className="FootfallInsights_main_open-side-bar-button"
              onClick={this.toggleSideBar}
            >
              <SVGIcon icon="back-arrow" />
            </button>
          )}
          <div className="FootfallInsights_main_top">
            <div className="container">
              <div className="FootfallInsights_title-bar">
                <div className="FootfallInsights_title-bar_left">
                  <h1>{insertTitle(this.props, this.state.showSelectionWarning)}</h1>
                  <h3>{insertSubTile(this.props, this.state.showSelectionWarning)}</h3>
                </div>
                <div className="FootfallInsights_date-range-group">
                {(Array.isArray(this.props.ableToDownloadCSV) &&
                  this.props.ableToDownloadCSV.length > 0 &&
                  this.props.client.props.enableAudienceBuilder !== true )
                  && (
                    <DownloadCSVButton
                      downloadAudience={downloadMobileDevices}
                      downloadingCSV={downloadingCSV}
                      label="Download audience .csv"
                      reportType='mobileDevices'
                      insightType={insightType}
                      ableToDownloadCSV={this.props.ableToDownloadCSV}
                    />
                  )}

                </div>
              </div>
              <div>
                {!this.state.showSelectionWarning && (
                  <LoadingContainer
                    loading={!mobileDevicesSummaryDataLoaded}
                  >
                    <div className="FootfallInsights_main_top_cards">
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {
                            isEmptyObject(mobileDevicesSummaryData) ?
                              ``
                              : (formatNumber(mobileDevicesSummaryData.deviceInsights))
                          }
                        </span>
                        device insights
                    </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {
                            isEmptyObject(mobileDevicesSummaryData) ?
                              ``
                              : (formatNumber(mobileDevicesSummaryData.uniqueDevices))
                          }
                        </span>
                        unique devices
                    </div>
                      <div className="content-card">
                        <span className="FootfallInsights_main_top_cards_info">
                          {
                            isEmptyObject(mobileDevicesSummaryData) ?
                              ``
                              : (formatNumber(mobileDevicesSummaryData.appsProfiled))
                          }

                        </span>
                        mobile applications profiled
                    </div>
                    </div>
                  </LoadingContainer>
                )}
              </div>
            </div>
          </div>
          <div className="FootfallInsights_reports container">
            <InsightsNavBar selectedReport={reportId} />

            {this.state.showSelectionWarning ? (
              <SelectionNotAvailable
                text={this.state.selectionWarningText}
                buttonText={this.state.selectionWarningButtonText}
              />
            ) : (
                <div className="FootfallInsights_reports_tab-panel">
                  <div className="FootfallInsights_reports_grid">

                    <div className="FootfallInsights_reports_grid_top">
                      <LoadingContainer
                        loading={!mobileDevicesApplicationDataLoaded}
                        className="FootfallInsights_reports_grid_top "
                      >
                        <MobileTableGraph
                          data={mobileDevicesApplicationData}
                          title="Installed apps insights"
                          rowPerpage={20}
                          headCells={headCellsApp}
                          isDataAvailable={isDataAvailable(mobileDevicesApplicationData)}
                          downloadOpen={searchStringInObjectArray('apps',this.props.ableToDownloadCSV,'value')}
                          downloadAudience={downloadMobileDevices}
                          downloadingCSV={downloadingCSV}
                          reportType='mobileDevices'
                          insightType={insightType}
                        />
                      </LoadingContainer>
                    </div>

                    <div className="FootfallInsights_reports_grid_middle">
                      <LoadingContainer
                        loading={!mobileDevicesReportDataLoaded}
                        className="FootfallInsights_reports_grid_top "
                      >
                        <MobileTableGraph
                          data={mobileDevicesReportData}
                          title="Device brand insights"
                          rowPerpage={5}
                          headCells={headCellsBrand}
                          isDataAvailable={isDataAvailable(mobileDevicesReportData)}
                          downloadOpen={searchStringInObjectArray('brands',this.props.ableToDownloadCSV,'value')}
                          downloadAudience={downloadMobileDevices}
                          downloadingCSV={downloadingCSV}
                          reportType='mobileDevices'
                          insightType={insightType}
                        />
                      </LoadingContainer>
                    </div>

                    <div className="FootfallInsights_reports_grid_bottom">
                      <LoadingContainer
                        loading={!mobileDevicesNetworkDataLoaded}
                        className="FootfallInsights_reports_grid_top "
                      >
                        <MobileTableGraph
                          data={mobileDevicesNetworkData}
                          title="Mobile networks insights"
                          rowPerpage={5}
                          headCells={headCellsNetwork}
                          isDataAvailable={isDataAvailable(mobileDevicesReportData)}
                          downloadOpen={searchStringInObjectArray('networks',this.props.ableToDownloadCSV,'value')}
                          downloadAudience={downloadMobileDevices}
                          downloadingCSV={downloadingCSV}
                          reportType='mobileDevices'
                          insightType={insightType}
                        />
                      </LoadingContainer>
                    </div>

                  </div>
                </div>

              )}
          </div>
          <div className="FootfallInsights_DownlaodPdf">
            <DownloadPdf
              reportType='MobileDevices'
              isDisabled={!(mobileDevicesNetworkDataLoaded
                && mobileDevicesReportDataLoaded
                && mobileDevicesApplicationDataLoaded
                && mobileDevicesSummaryDataLoaded
                && !this.state.showSelectionWarning)
              } />
            <CopyrightAndVersion />
          </div>
        </main>
      </div>
    );
  }
}

MobileDevicesInsights.propTypes = {
  client: PropTypes.object.isRequired, // eslint-disable-line
  report: PropTypes.object.isRequired, // eslint-disable-line
  reportId: PropTypes.string.isRequired,

};

MobileDevicesInsights.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
  mobileDevicesSummaryData: {}
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileDevicesInsights);
